import script from "./MapLegendRouteComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MapLegendRouteComponent.vue?vue&type=script&setup=true&lang=js"

import "./MapLegendRouteComponent.vue?vue&type=style&index=0&id=203c2795&lang=css"

const __exports__ = script;

export default __exports__